import { render, staticRenderFns } from "./basic-chart-datagrid-visualizer.vue?vue&type=template&id=41fd27ad&scoped=true&"
import script from "./basic-chart-datagrid-visualizer.vue?vue&type=script&lang=js&"
export * from "./basic-chart-datagrid-visualizer.vue?vue&type=script&lang=js&"
import style0 from "./basic-chart-datagrid-visualizer.vue?vue&type=style&index=0&id=41fd27ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd27ad",
  null
  
)

export default component.exports